export interface ProductTeaserPropConfigSchema {
  baseURL: string | "";
  cartURL: string | "";
}
export class ProductTeaserPropConfig {
  private static instance: ProductTeaserPropConfig;

  config: ProductTeaserPropConfigSchema = {
    baseURL: "",
    cartURL: "",
  };

  private constructor(p_config: ProductTeaserPropConfigSchema) {
    this.config = p_config;
  }
  getConfig = () => {
    return this.config;
  };

  getBaseUrl = () => {
    return this.config?.baseURL ?? "";
  };

  getCartUrl = () => {
    return this.config?.cartURL ?? "";
  };

  public static getInstance = (): ProductTeaserPropConfig => {
    return ProductTeaserPropConfig.instance;
  };
  public static create = (p_config: ProductTeaserPropConfigSchema): void => {
    ProductTeaserPropConfig.instance = new ProductTeaserPropConfig(p_config);
  };
}
